import {
  Animated,
  Easing,
  FlatList,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { Colors, Metrics, Typography } from "../../resources";
import React, { useEffect, useRef, useState } from "react";
import { STagType, TagMap } from "../../types";

import SDivider from "../atoms/SDivider";
import STagsBar from "../molecules/STagsBar";
import { useTags } from "../../hooks";

interface IProps {
  isOpen: boolean;
  maxHeight: number;
  resetSearch: () => void;
}

const STagsScrolledView: React.FC<IProps> = ({
  isOpen,
  maxHeight,
  resetSearch,
}) => {
  const heightRef = useRef<Animated.Value>(new Animated.Value(0));

  const { tags, categories } = useTags();

  useEffect(() => {
    const stop = isOpen ? maxHeight : 0;

    Animated.timing(heightRef.current, {
      toValue: stop,
      duration: 0,
      easing: Easing.inOut(Easing.linear),
      useNativeDriver: true,
    }).start();
  }, [isOpen]);

  const renderCategory = ({ item }: { item: string }) => {
    const _tags: TagMap = {};

    Object.keys(tags).map((id: string) => {
      if (tags[id].category === item) {
        _tags[id] = tags[id];
      }
    });
    return (
      <View style={styles.listtRow}>
        <View style={styles.textContainer}>
          <Text style={styles.category}>{item.toUpperCase()}</Text>
        </View>
        <STagsBar
          tags={_tags}
          type={STagType.Numbered}
          height={Metrics.paddingExtraMedium}
          flexWrap
        />
      </View>
    );
  };

  return (
    <Animated.View style={[styles.container, { height: heightRef.current }]}>
      <FlatList
        data={categories}
        extraData={tags}
        renderItem={renderCategory}
        keyExtractor={(item) => item}
        ItemSeparatorComponent={() => (
          <View style={{ paddingHorizontal: Metrics.padding32 }}>
            <SDivider height={1} color={Colors.grey200} width="100%" />
          </View>
        )}
      />
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    backgroundColor: Colors.grey000,
    borderBottomColor: Colors.grey200,
    borderBottomWidth: 1,
  },
  listtRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: Metrics.padding32,
  },
  textContainer: {
    height: "100%",
    width: Metrics.size86,
    alignItems: "flex-end",
    justifyContent: "flex-start",
    marginRight: Metrics.paddingSmallStandard,
    marginTop: Metrics.padding20,
  },
  category: {
    ...Typography.bodyBold,
  },
});

export default STagsScrolledView;
